import { MenuItem } from "@chakra-ui/react";
import { AddEntityButton } from "features/entities/AddEntityButton";
import { EntitiesTableContent } from "features/entities/EntitiesTableContent";
import { useTranslation } from "react-i18next";
import { QueryBoundary } from "shared/api/QueryBoundary";
import PageBody from "shared/components/layout/PageBody";
import PageContainer from "shared/components/layout/PageContainer";
import PageContent from "shared/components/layout/PageContent";
import { RouteLink } from "shared/components/link/RouteLink";
import { TableBox } from "shared/components/table/box/TableBox";
import { TableBoxActionsMenu } from "shared/components/table/box/TableBoxActionsMenu";
import { TableBoxHeader } from "shared/components/table/box/TableBoxHeader";
import { TableBoxTitle } from "shared/components/table/box/TableBoxTitle";
import { DataTableBoxActions } from "shared/components/table/data/DataTableBoxActions";
import useDocumentTitle from "shared/hooks/useDocumentTitle";
import { rootRoute } from "shared/navigation/Routes";

export const EntitiesListPage: React.FC = () => {
  const { t } = useTranslation(["address", "common", "entity"]);
  useDocumentTitle(t("common:entities"));

  return (
    <PageContainer>
      <PageContent isFullHeight={true} hasHeader={false}>
        <PageBody>
          <TableBox>
            <TableBoxHeader>
              <TableBoxTitle>{t("common:entities")}</TableBoxTitle>
              <DataTableBoxActions
                endChildren={
                  <TableBoxActionsMenu>
                    <MenuItem
                      as={RouteLink}
                      to={rootRoute({}).entities({}).bulkAddBanks({}).$}
                    >
                      {t("entity:bulkAddBanks.cta")}
                    </MenuItem>
                    <MenuItem
                      as={RouteLink}
                      to={rootRoute({}).entities({}).bulkAddContacts({}).$}
                    >
                      {t("entity:bulkAddContacts.cta")}
                    </MenuItem>
                  </TableBoxActionsMenu>
                }
              >
                <AddEntityButton size="xs" />
              </DataTableBoxActions>
            </TableBoxHeader>
            <QueryBoundary>
              <EntitiesTableContent />
            </QueryBoundary>
          </TableBox>
        </PageBody>
      </PageContent>
    </PageContainer>
  );
};
